import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { PartnerReferralCode } from '../types/partnerReferralCode';
import { partnerReferralCodeQueryKeys } from './usePartnerReferralCodes';

type DefaultError = unknown;

type UsePartnerReferralCodeParams = {
  id: string;
  enabled?: boolean;
};

export function usePartnerReferralCode<
  TData = PartnerReferralCode,
  TError = DefaultError,
>(
  { id, enabled = true }: UsePartnerReferralCodeParams,
  options?: Omit<
    UseQueryOptions<PartnerReferralCode, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  return useQuery<PartnerReferralCode, TError, TData>({
    queryKey: partnerReferralCodeQueryKeys.detail(id),
    enabled: enabled && !!id,
    queryFn: async () => service.getPartnerReferralCodeById(id),
    ...(options as any),
  });
}
